__turbopack_context__.v({
  "app_light_theme": "AddToFavorires-module-scss-module__33lSRa__app_light_theme",
  "inFavorites": "AddToFavorires-module-scss-module__33lSRa__inFavorites",
  "root": "AddToFavorires-module-scss-module__33lSRa__root",
});
